import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import api from '@api';
import DefaultImg from "../../images/default_image.png";
import { useDomain } from '@useDomain';


function DefaultPlayersPage() {
 const [players, setPlayers] = useState([]);
 const [selectedLeague, setSelectedLeague] = useState("");
 const [selectedTeam, setSelectedTeam] = useState("");
 const [searchTerm, setSearchTerm] = useState("");
 const [loading, setLoading] = useState(true);


 const { domain, slug } = useDomain(); // ✅ Centralized domain/slug
console.log('hello')
 useEffect(() => {
  const fetchPlayers = async () => {
   try {
    setLoading(true); // Start loader
    const response = await api.get(`/api/playersv2`, {
     params: slug ? { slug } : { domain },
    });
    setPlayers(response.data.players);
   } catch (error) {
    console.error("Error fetching players:", error);
   } finally {
    setLoading(false); // ✅ End loader (critical!)
   }
  };

  if (domain || slug) fetchPlayers();
 }, [domain, slug]);


 const allLeagues = players.flatMap(p =>
  p.rosters?.map(r => r?.league?.id).filter(Boolean)
 );


 const uniqueLeagues = [...new Set(allLeagues)];
 const leagueOptions = players
  .flatMap(p => p.rosters || []).filter(r =>
   r.league?.id &&
   r.seasons_leagues_team?.seasons_league?.season?.active
  )

  .reduce((acc, r) => {
   if (!acc.some(l => l.id === r.league.id)) {
    acc.push({ id: r.league.id, name: r.league.name });
   }
   return acc;
  }, [])
  .sort((a, b) => a.name.localeCompare(b.name));





 const filteredTeams = players
  .flatMap(p => p.rosters || [])
  .filter(r =>
   r.team?.id &&
   (!selectedLeague || r.league?.id === Number(selectedLeague)) &&
   r.seasons_leagues_team?.seasons_league?.season?.active
  )

  .reduce((acc, r) => {
   if (!acc.some(t => t.id === r.team.id)) {
    acc.push({ id: r.team.id, name: r.team.name });
   }
   return acc;
  }, [])
  .sort((a, b) => a.name.localeCompare(b.name));




 const filteredPlayers = players
  .filter(player => {
   const fullName = `${player.firstName} ${player.lastName}`.toLowerCase();
   const matchesSearch = fullName.includes(searchTerm.toLowerCase());
   const matchesLeague = selectedLeague
    ? player.rosters?.some(r => r.league?.id === Number(selectedLeague))
    : true;

   const matchesTeam = selectedTeam
    ? player.rosters?.some(r => r.team?.id === Number(selectedTeam))
    : true;

   return matchesSearch && matchesLeague && matchesTeam;
  })
  .sort((a, b) =>
   `${a.firstName} ${a.lastName}`.localeCompare(`${b.firstName} ${b.lastName}`)
  );

 const shouldShow = true

 // return (
 //   <div className="playerList_public">
 //     {players.length === 0 ? (
 //       <p></p>
 //     ) : (
 //       <>
 //           <input
 //             type="text"
 //             placeholder="Search player name..."
 //             value={searchTerm}
 //             onChange={(e) => setSearchTerm(e.target.value)}
 //             className="player-search"
 //           />


 //         <div className="filters">
 //           <select value={selectedLeague} onChange={(e) => {
 //             setSelectedLeague(e.target.value);
 //             setSelectedTeam("");
 //           }}>
 //             <option value="">All Leagues</option>
 //             {leagueOptions.map(l => (
 //               <option key={l.id} value={l.id}>{l.name}</option>
 //             ))}
 //           </select>

 //           <select
 //             value={selectedTeam}
 //             onChange={(e) => setSelectedTeam(e.target.value)}
 //             disabled={!selectedLeague}
 //           >
 //             <option value="">All Teams</option>
 //             {filteredTeams.map(t => (
 //               <option key={t.id} value={t.id}>{t.name}</option>
 //             ))}
 //           </select>
 //         </div> 

 //         <div className="public-player-container">
 //             {filteredPlayers.map((player) => (
 //               <div key={player.id} className="player-public-card">
 //                 <NavLink
 //                   to={slug ? `/${slug}/players/${player.id}` : `/players/${player.id}`}
 //                   className="player-link"
 //                 >
 //                   <img
 //                     src={player.image ? player.image : DefaultImg}
 //                     alt={player.firstName}
 //                     className="player-public-image"
 //                   />
 //                   <p className="player-public-name">{player.firstName} {player.lastName}</p>
 //                 </NavLink>
 //               </div>
 //             ))}

 //         </div>
 //       </>
 //     )}
 //   </div>

 // );
 if (loading) {
  return (
   <div className="playerList_public loading-container">
    <div className="spinner" />
    <p>Loading players...</p>
   </div>
  );
 }


 return (
  <div className="playerList_public">
   {players.length === 0 ? (
    <p></p>
   ) : (
    <>
     <input
      type="text"
      placeholder="Search player name..."
      value={searchTerm}
      onChange={(e) => setSearchTerm(e.target.value)}
      className="player-search"
     />

     <div className="filters">
      <select value={selectedLeague} onChange={(e) => {
       setSelectedLeague(e.target.value);
       setSelectedTeam("");
      }}>
       <option value="">-- LEAGUES --</option>
       {leagueOptions.map(l => (
        <option key={l.id} value={l.id}>{l.name}</option>
       ))}
      </select>

      <select
       value={selectedTeam}
       onChange={(e) => setSelectedTeam(e.target.value)}
      >
       <option value="">-- TEAMS --</option>
       {filteredTeams.map(t => (
        <option key={t.id} value={t.id}>{t.name}</option>
       ))}
      </select>
     </div>
      {shouldShow && (
       <div className="public-player-container">
        {filteredPlayers.map(player => (
         <div key={player.id} className="player-public-card">
          <NavLink
           to={slug ? `/${slug}/players/${player.id}` : `/players/${player.id}`}
           className="player-link"
          >
           <img
            src={player.image || DefaultImg}
            alt={player.firstName}
            className="player-public-image"
           />
           <p className="player-public-name">
            {player.firstName} {player.lastName}
           </p>
          </NavLink>
         </div>
        ))}
       </div>
      )}


    </>
   )}
  </div>
 );

}

export default DefaultPlayersPage;
